<div class="vh-100 d-flex flex-column">
  <div class="d-flex">
    <mat-toolbar class="mat-toolbar">
      <div class="d-flex topNav align-items-center">
        <a class="logo-div-size" *ngIf="logoUrl" href="/">
          <img src="{{logoUrl}}" class="logo" />
        </a>
        <div class="d-flex align-items-center top-navigation desktopView">
          <app-mat-tabs></app-mat-tabs> 
        </div>
        <div class="flex-fill"></div>
        <div class="d-flex align-items-center">
          <app-language-selector></app-language-selector>
        </div>
        <div class="d-flex align-items-center ms-1">
          <div class="menu-button profile" [matMenuTriggerFor]="menuProfile">
            <ng-container *ngIf="!mobileMedia.matches && userInfo; else loginMenu">
              <app-avatar [firstName]="userInfo.firstname" [lastName]="userInfo.lastname"
                [image]="userInfo.avatar"></app-avatar>
              <span class="menu-button-text displayName username">{{ displayName }}</span>
            </ng-container>
            <ng-template #loginMenu>
              <mat-icon>account_circle </mat-icon>
            </ng-template>
          </div>
          <mat-menu #menuProfile="matMenu">
            <ng-container *ngIf="isAuthenticated; else menuUnauthenticated">
              <ng-container
                *ngIf="!mobileMedia.matches && hasAdminRights && { value: isAdminRoute$ | async } as isAdminRoute">
                <button *ngIf="isAdminRoute.value" mat-menu-item type="button" [routerLink]="['/']">
                  {{ 'Navigation.GoToHome' | translate }}
                </button>
                <button *ngIf="!isAdminRoute.value" mat-menu-item type="button" [routerLink]="['/admin']">
                  {{ 'Navigation.GoToAdmin' | translate }}
                </button>
              </ng-container>
              <button mat-menu-item type="button" (click)="myProfile()">
                {{ 'Navigation.Profile' | translate }}
              </button>
              <button mat-menu-item type="button" (click)="logout()">
                {{ 'Navigation.Logout' | translate }}
              </button>
            </ng-container>
            <ng-template #menuUnauthenticated>
              <button mat-menu-item type="button" (click)="onLogin()">
                {{ 'Navigation.Login' | translate }}
              </button>
            </ng-template>
          </mat-menu>
        </div>
      </div>
      <div class="mobileView">
        <button mat-icon-button (click)="collapse()">
          <mat-icon>{{ collapsed ? 'reorder' : 'clear' }}</mat-icon>
        </button>
      </div>
    </mat-toolbar>
  </div>
  <div class="mobileView">
        <app-mat-tabs></app-mat-tabs> 
  </div>
  <div class="d-flex flex-grow-1 overflow-hidden">
    <div class="navigation overflow-auto overlayMobile" [class]="sideMenuClass">
      <div class="text-end px-2 pb-4 mr-2 desktopView">
        <button class="bg-white position-absolute chevron-design shadow" mat-icon-button color="accent"
          (click)="collapse()">
          <mat-icon>{{ collapsed ? 'chevron_right' : 'chevron_left' }}</mat-icon>
        </button>
      </div>
      <mat-nav-list *ngIf="{ value: isAdminRoute$ | async } as isAdminRoute" class="pt-3">
        <ng-container *ngIf="isAdminRoute.value; else homeNav">
          <app-nav-list-item [_routerLink]="['/admin/cms']" icon="dashboard"
            label="{{ 'Navigation.Admin.CMS' | translate }}" [collapsed]="collapsed">
            <app-nav-list-item [_routerLink]="['/admin/cms/blog']" icon="text_snippet"
              label="{{ 'Navigation.Admin.Blogs' | translate }}" [collapsed]="collapsed">
            </app-nav-list-item>
            <app-nav-list-item [_routerLink]="['/admin/cms/category']" icon="category"
              label="{{ 'Navigation.Admin.BlogCategories' | translate }}" [collapsed]="collapsed">
            </app-nav-list-item>
            <app-nav-list-item [_routerLink]="['/admin/cms/tag']" icon="tag"
              label="{{ 'Navigation.Admin.BlogTags' | translate }}" [collapsed]="collapsed">
            </app-nav-list-item>
            <app-nav-list-item [_routerLink]="['/admin/cms/home-view']" icon="home"
              label="{{ 'Navigation.HomeView' | translate }}" [collapsed]="collapsed">
            </app-nav-list-item>
            <app-nav-list-item [_routerLink]="['/admin/cms/idea']" icon="lightbulb"
              label="{{ 'Navigation.Idea' | translate }}" [collapsed]="collapsed">
            </app-nav-list-item>
            <app-nav-list-item [_routerLink]="['/admin/cms/foundation']" icon="rocket_launch"
              label="{{ 'Navigation.Foundation' | translate }}" [collapsed]="collapsed">
            </app-nav-list-item>
            <app-nav-list-item [_routerLink]="['/admin/cms/startphase']" icon="trending_up"
              label="{{ 'Navigation.Growth' | translate }}" [collapsed]="collapsed">
            </app-nav-list-item>
            <app-nav-list-item [_routerLink]="['/admin/cms/scaling']" icon="change_circle"
              label="{{ 'Navigation.Succession' | translate }}" [collapsed]="collapsed">
            </app-nav-list-item>
            <app-nav-list-item [_routerLink]="['/admin/cms/help-texts']" icon="help"
              label="{{ 'Navigation.Admin.Helptexts' | translate }}" [collapsed]="collapsed">
            </app-nav-list-item>
            <app-nav-list-item [_routerLink]="['/admin/cms/info-texts']" icon="info"
              label="{{ 'Navigation.Admin.Infotexts' | translate }}" [collapsed]="collapsed">
            </app-nav-list-item>
            <app-nav-list-item [_routerLink]="['/admin/cms/emails']" icon="email"
              label="{{ 'Navigation.Admin.Emails' | translate }}" [collapsed]="collapsed">
            </app-nav-list-item>
            <app-nav-list-item [_routerLink]="['/admin/cms/incorporation-view']" icon="rocket_launch"
              label="{{ 'Navigation.Admin.IncorporationView' | translate }}" [collapsed]="collapsed">
            </app-nav-list-item>
            <app-nav-list-item [_routerLink]="['/admin/cms/mutation-view']" icon="change_circle"
              label="{{ 'Navigation.Admin.MutationView' | translate }}" [collapsed]="collapsed">
            </app-nav-list-item>
            <app-nav-list-item [_routerLink]="['/admin/cms/business-model-canvas-overview-view']" icon="view_column"
              label="{{ 'Navigation.Admin.BusinessModelCanvas' | translate }}" [collapsed]="collapsed">
            </app-nav-list-item>
            <app-nav-list-item [_routerLink]="['/admin/cms/business-plan-overview-view']" icon="list_alt"
              label="{{ 'Navigation.Admin.BusinessPlan' | translate }}" [collapsed]="collapsed">
            </app-nav-list-item>
          </app-nav-list-item>

          <app-nav-list-item [_routerLink]="['/admin/administration']" icon="add_home_work"
            label="{{ 'Navigation.Admin.Administration' | translate }}" [collapsed]="collapsed">
            <app-nav-list-item [_routerLink]="['/admin/administration/accounts']" icon="manage_accounts"
              label="{{ 'Navigation.Admin.Accounts' | translate }}" [collapsed]="collapsed">
            </app-nav-list-item>
            <app-nav-list-item [_routerLink]="['/admin/administration/statistics']" icon="analytics"
              label="{{ 'Navigation.Admin.Statistics' | translate }}" [collapsed]="collapsed">
            </app-nav-list-item>
            <app-nav-list-item [_routerLink]="['/admin/administration/documents']" icon="file_copy"
              label="{{ 'Navigation.Admin.Documents' | translate }}" [collapsed]="collapsed">
            </app-nav-list-item>
            <app-nav-list-item [_routerLink]="['/admin/administration/about']" icon="info"
              label="{{ 'Navigation.Admin.About' | translate }}" [collapsed]="collapsed">
            </app-nav-list-item>
          </app-nav-list-item>

          <app-nav-list-item [_routerLink]="['/admin/theme']" icon="color_lens"
            label="{{ 'Navigation.Admin.Design' | translate }}" [collapsed]="collapsed">
          </app-nav-list-item>
        </ng-container>
        <ng-template #homeNav>
          <app-nav-list-item [_routerLink]="['/home-view']" icon="dashboard"
            label="{{ 'Navigation.HomeView' | translate }}" (click)="onMobileClickCollapse()" [collapsed]="collapsed">
          </app-nav-list-item>
          <app-nav-list-item [_routerLink]="['/tools']" icon="construction" label="{{ 'Navigation.Tools' | translate }}"
            [collapsed]="collapsed">
            <app-nav-list-item [_routerLink]="['/tools/businessplan']" icon="list_alt"
              label="{{ 'Navigation.Businessplan' | translate }}" (click)="onMobileClickCollapse()"
              [collapsed]="collapsed">
            </app-nav-list-item>
            <app-nav-list-item [_routerLink]="['/tools/business-model-canvas']" icon="view_column"
              label="{{ 'Navigation.BusinessModelCanvas' | translate }}" (click)="onMobileClickCollapse()"
              [collapsed]="collapsed">
            </app-nav-list-item>
          </app-nav-list-item>

          <app-nav-list-item [_routerLink]="['/services']" icon="credit_card"
            label="{{ 'Navigation.Services' | translate }}" [collapsed]="collapsed">
            <app-nav-list-item [_routerLink]="['/services/incorporation']" icon="rocket_launch"
              label="{{ 'Navigation.IncorporationService' | translate }}" (click)="onMobileClickCollapse()"
              [collapsed]="collapsed">
            </app-nav-list-item>
            <app-nav-list-item [_routerLink]="['/services/mutation']" icon="change_circle"
              label="{{ 'Navigation.MutationService' | translate }}" (click)="onMobileClickCollapse()"
              [collapsed]="collapsed">
            </app-nav-list-item>
          </app-nav-list-item>

          <app-nav-list-item [_routerLink]="['/blog']" icon="blur_on" label="{{ 'Navigation.Blog' | translate }}"
            (click)="onMobileClickCollapse()" [collapsed]="collapsed">
          </app-nav-list-item>
        </ng-template>
      </mat-nav-list>
      <div class="align-items-center line ms-1 mobileView userInfoContainer">
        <div class="userInfo">
          <div class="menu-button profile" [matMenuTriggerFor]="menuMobileProfile">
            <ng-container *ngIf="userInfo; else displayLogin">
              <app-avatar [firstName]="userInfo.firstname" [lastName]="userInfo.lastname"
                [image]="userInfo.avatar"></app-avatar>
              <span class="menu-button-text displayName username">{{ displayName }}</span>
            </ng-container>
            <ng-template #displayLogin>
              <button mat-button type="button" (click)="onLogin()">
                {{ 'Navigation.Login' | translate }}
              </button>
            </ng-template>
          </div>
        </div>
        <mat-menu #menuMobileProfile="matMenu">
          <button mat-menu-item type="button" (click)="myProfile()">
            {{ 'Navigation.Profile' | translate }}
          </button>
          <ng-container *ngIf="isAuthenticated; else menuUnauthenticated">
            <button mat-menu-item type="button" (click)="logout()">
              {{ 'Navigation.Logout' | translate }}
            </button>
          </ng-container>
          <ng-template #menuUnauthenticated>
            <button mat-menu-item type="button" (click)="onLogin()">
              {{ 'Navigation.Login' | translate }}
            </button>
          </ng-template>
        </mat-menu>
      </div>
    </div>
    <div class="flex-fill content overflow-auto">
      <div class="container-fluid p-4">
        <router-outlet></router-outlet>
      </div>
      <app-app-footer></app-app-footer>
    </div>
  </div>
</div>
